class BajraDynamicHome extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.bajra-slide')];
    this.dots = [...this.querySelectorAll('.bajra-hero__dot')];
    this.active = 0;
    this.speed = Number(this.dataset.speed || 5) * 1000;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
    if (this.slides.length > 1 && !this.reduceMotion) this.start();
    this.setupReveal();
    this.setupStats();
    this.setupProgress();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    window.removeEventListener('scroll', this.progressHandler);
  }

  show(index, restart = false) {
    this.active = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.active));
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.active);
      dot.setAttribute('aria-current', i === this.active ? 'true' : 'false');
    });
    if (restart && !this.reduceMotion) this.start();
  }

  start() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.show(this.active + 1), this.speed);
  }

  setupReveal() {
    const items = this.querySelectorAll('.bajra-reveal');
    if (this.reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });
    items.forEach((item) => observer.observe(item));
  }

  setupStats() {
    const stats = this.querySelectorAll('[data-bajra-count]');
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const node = entry.target;
        const target = Number(node.dataset.bajraCount);
        const suffix = node.dataset.suffix || '';
        const start = performance.now();
        const duration = this.reduceMotion ? 0 : 1200;
        const frame = (now) => {
          const progress = duration === 0 ? 1 : Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          node.textContent = `${Math.round(target * eased).toLocaleString()}${suffix}`;
          if (progress < 1) requestAnimationFrame(frame);
        };
        requestAnimationFrame(frame);
        observer.unobserve(node);
      });
    }, { threshold: .5 });
    stats.forEach((stat) => observer.observe(stat));
  }

  setupProgress() {
    const bar = this.querySelector('.bajra-scroll-progress');
    if (!bar) return;
    this.progressHandler = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      bar.style.width = `${max > 0 ? (scrollY / max) * 100 : 0}%`;
    };
    window.addEventListener('scroll', this.progressHandler, { passive: true });
    this.progressHandler();
  }
}

if (!customElements.get('bajra-dynamic-home')) customElements.define('bajra-dynamic-home', BajraDynamicHome);
